import { render } from "./SucursalList.vue?vue&type=template&id=3732cadd&scoped=true"
import script from "./SucursalList.vue?vue&type=script&lang=js"
export * from "./SucursalList.vue?vue&type=script&lang=js"

import "./SucursalList.vue?vue&type=style&index=0&id=3732cadd&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3732cadd"]])

export default __exports__